import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";
import Button from "../../components/common/Button";
import { getJoinLink } from "../../backend/landing/joinLink";
import { getWeekendInfoByName } from "../../backend/weekends/weekendInfo";
import { sanitizeHTML } from "../../utils/htmlSanitizer";
import { Helmet } from "react-helmet-async";

const LandingHero = ({ weekendId }: {weekendId:number}) => {
  const showBigLogo = useMediaQuery({ query: `(min-width: 1024px)` });
  const isMobile = useMediaQuery({ query: `(max-width: 768px)` });

  return (
    <div style={styles.heroWrapper}>
      <Helmet>
        <meta property="og:title" content={getWeekendInfoByName(weekendId,"metaTitle")} />
        <meta property="og:description" content={getWeekendInfoByName(weekendId,"metaDescription")} />
      </Helmet>
      <div style={styles.heroContainer}>
        <h1
          style={{
            ...styles.mainHeading,
            fontSize: isMobile ? "14vw" : "clamp(5rem,8vw,11rem)",
            lineHeight: isMobile ? "13vw" : "clamp(5rem,8vw,10rem)",
          }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(getWeekendInfoByName(weekendId,"name").replace("<m?>",isMobile?"<br/>":"").replace("<d?>",!isMobile?"<br/>":"")) }}
        ></h1>
        <p
          style={{
            ...styles.dateHeading,
            fontSize: isMobile ? "12vw" : "clamp(3rem,4vw,5rem)",
            lineHeight: isMobile ? "11vw" : "",
          }}
        >
          {getWeekendInfoByName(weekendId,"date")}
        </p>
      

        <h2
          style={{
            marginBottom: isMobile ? "3rem" : "0rem",
            fontSize: isMobile ? "7vw" : "clamp(2rem,2.5vw,2.7rem)",
            fontWeight:"normal",
          }}
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(getWeekendInfoByName(weekendId, "description")) }}
        >
          
        </h2>
        <div style={{ display: "flex", flexDirection: "row", zIndex: "1" }}>
          <Button
            text={"ПОДАТИ ЗАЯВКУ"}
            external_link={getJoinLink(weekendId)}
            textColor="var(--black)"
            hoverTextColor="var(--orange)"
            border="3px solid var(--black)"
            hoverBorder="3px solid var(--black)"
            backgroundColor="var(--orange)"
            hoverBackgroundColor="var(--black)"
            fontSize={isMobile ? "8vw" : "3rem"}
            padding="1rem 2rem"
            marginBottom={isMobile ? "3.5rem" : undefined}
            transform={isMobile ? undefined : "translateY(50%)"}
            fontWeight="bold"
            containerProps={isMobile ? { width: "var(--main-container-width)" } : {}}
            isSimple={true}
          />
        </div>
        {showBigLogo && (
          <div style={styles.logoContainer}>
            <img src="assets/icons/210-logo-big-bw.svg" alt={"Big logo"} style={styles.logoStyle} />
          </div>
        )}
      </div>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  heroWrapper: {
    display: "flex",
    width: "100%",
    backgroundColor: "var(--olive)",
    overflow: "visible",
  },
  heroContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    width: "var(--main-container-width)",
    margin: "0 auto",
    marginTop: "3.5rem",
  },
  mainHeading: {
    color: "var(--black)",
    fontFamily: "UAFSans-Black",
    marginBottom: "2rem",
    fontWeight:"normal",
  },
  dateHeading: {
    color: "var(--white)",
    fontWeight: "bold",
    marginBottom: "2rem",
  },
  logoContainer: {
    position: "absolute",
    top: "var(--header-height)",
    left: 0,
    width: "100%",
    overflow: "hidden",
  },
  logoStyle: {
    position: "relative",
    left: "calc(100vw - var(--main-container-margin) + 10rem - clamp(0rem,5vw,10rem))",
    height: "calc(clamp(40rem,50vw,50rem) - 40px)",
    transform: "translateX(-65%)",
  },
};

export default LandingHero;
